import { Box, Typography } from '@mui/material';
import IconButton from 'components/IconButton';
import React from 'react';

function QuantityInput({
  value: qty,
  max,
  min = 0,
  disabled,
  onChange,
  size = 32,
  ...props
}) {
  const minDisabled = disabled || qty <= min;
  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 1,
        mr: 1,
        gap: 1,
        ...props.sx,
      }}
    >
      <IconButton
        name={qty === 1 && !minDisabled ? 'trash-outlined' : 'minus'}
        disabled={minDisabled}
        sx={{
          p: '2px !important',
          color: qty === 1 && !minDisabled ? 'error.main' : 'inherit',
          height: 32,
          width: 32,
          '.MuiButton-startIcon>*': {
            fontSize: `${qty === 1 && !minDisabled ? 20 : 24 }px !important`,
          },
        }}
        onClick={() => {
          onChange(qty - 1);
        }}
      />
      <Typography
        fontWeight="fontWeightMedium"
        sx={{
          userSelect: 'none',
        }}
      >
        {qty}
      </Typography>
      <IconButton
        name="plus"
        sx={{
          p: '2px !important',
          height: 32,
          width: 32,
        }}
        disabled={disabled || qty >= max}
        onClick={() => {
          onChange(qty + 1);
        }}
      />
    </Box>
  );
}

export default QuantityInput;


